import tenantConfig from "./config/tenant";

export const settings = {
  APP_NAME: tenantConfig.appName,
  API_SERVER: "/personal-training-BE/",
  SCOTTISH_FOOTBALL_API_URL:
    process.env.VUE_APP_SCOTTISH_FOOTBALL_API_URL ||
    "http://localhost:8888/scottish-football-data/api/",
  CLUB_NAME: tenantConfig.name,
  CLUB_NAME_SHORT: tenantConfig.nameShort,
  CLUB_ID: tenantConfig.clubId,
};

// Export tenant utilities for backward compatibility and convenience
export const {
  getTenantId,
  getTenantName,
  getTenantNameShort,
  getClubId,
  getAppName,
  getDomain,
  isFeatureEnabled,
  isIntegrationEnabled,
  getIntegrationConfig,
  getAssetPath,
  getDatabaseConfig,
  getManifestConfig,
} = require("./config/tenant");
